import React, { ReactElement } from 'react';
import {Route, Switch } from 'react-router-dom';
import { RouteConfig } from '../models/route.model';
import RoutesConfig from '../RoutesConfig';
import SSO from '../../modules/sso/sso';

const Public = (): ReactElement => {
  return (
    <Switch>
      <Route exact path="/sso-saml" component={SSO} />
      {RoutesConfig.publicRoutes.map(
        ({ path, component }: RouteConfig): ReactElement => {
    
          return (
            <Route exact={true} key={path} path={path} component={component}/>
          );
        }
      )}
    </Switch>
  );
};

export default Public;
